export enum UserRole {
  SuperAdmin = 'ROLE_SUPER_ADMIN',
  Admin = 'ROLE_ADMIN',
  User = 'ROLE_USER',
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SuperAdmin]: 'Super Admin',
  [UserRole.Admin]: 'Admin',
  [UserRole.User]: 'Staff',
};

export const ROLE_RANK: Record<UserRole, number> = {
  [UserRole.SuperAdmin]: 2,
  [UserRole.Admin]: 1,
  [UserRole.User]: 0,
};

export function isAtLeast(role: UserRole, minimum: UserRole): boolean {
  return ROLE_RANK[role] >= ROLE_RANK[minimum];
}

export function canGrant(
  userRole: UserRole | undefined,
  role: UserRole
): boolean {
  if (!userRole) {
    return false;
  }
  if (!isAtLeast(userRole, UserRole.Admin)) {
    return false;
  }
  return userRole === UserRole.SuperAdmin || role !== UserRole.SuperAdmin;
}

export function getAssignableUserRoleOptions(
  userRole: UserRole
): { value: UserRole; label: string }[] {
  return [UserRole.User, UserRole.Admin, UserRole.SuperAdmin]
    .filter((role) => canGrant(userRole, role))
    .map((role) => ({ value: role, label: ROLE_LABELS[role] }));
}
